import { render } from "./points.vue?vue&type=template&id=1b5b0ea7&scoped=true"
import script from "./points.vue?vue&type=script&lang=js"
export * from "./points.vue?vue&type=script&lang=js"

import "./points.vue?vue&type=style&index=0&id=1b5b0ea7&lang=scss"
import "./points.vue?vue&type=style&index=1&id=1b5b0ea7&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5b0ea7"]])

export default __exports__